import '@static/index.css';
import './utils/i18n/i18n';

import { FloatingDelayGroup } from '@floating-ui/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { getApplicationContainer } from '@toggle/helpers';
import * as React from 'react';
import { createRoot } from 'react-dom/client';

import { Routes } from '~/routes';
import { queryClient } from '~/services/query-client/queryClient';
import { Tracking } from '~/services/tracking';
import { PostHogProvider } from '~/services/tracking/posthog/PostHogProvider';

Tracking.initialise();

const root = createRoot(getApplicationContainer(), {
  onUncaughtError: (error, errorInfo) => {
    Tracking.captureException(error, {
      componentStack: errorInfo.componentStack ?? '',
    });
  },
  onRecoverableError: (error, errorInfo) => {
    Tracking.captureException(error, {
      componentStack: errorInfo.componentStack ?? '',
    });
  },
});

root.render(
  <PostHogProvider>
    <QueryClientProvider client={queryClient}>
      <FloatingDelayGroup delay={{ open: 300, close: 0 }} timeoutMs={300}>
        <Routes />
      </FloatingDelayGroup>
    </QueryClientProvider>
  </PostHogProvider>
);
